export default __webpack_public_path__ + "images/SpeakersPhotos/foto jose luis del val.jpg?0c089f97";